import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import Button from '@mui/material/Button'

interface SystemMessageProps {
	message: string
	goBackHref?: string
	reset?: () => void
}
export const SystemMessage = ({ message, goBackHref, reset }: SystemMessageProps) => {
	return (
		<Box display='flex' flexDirection='column' textAlign='center' mt={4} gap={2}>
			<Typography variant='subtitle1'>{message}</Typography>
			{!!goBackHref && <Link href={goBackHref}>Go back</Link>}
			{!!reset && (
				<Box>
					<Button onClick={reset} variant='outlined' size='small'>
						Try again
					</Button>
				</Box>
			)}
		</Box>
	)
}
